export default __webpack_public_path__ + "static/media/new-banner.ef9f600e.jpg";